var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDocument2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 127,
    height: 85,
    viewBox: "0 0 127 85",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_719_7973)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M112.156 78.2017C112.156 79.8163 111.514 81.3647 110.373 82.5063C109.231 83.648 107.682 84.2893 106.068 84.2893C104.453 84.2893 102.905 83.648 101.763 82.5063C100.622 81.3647 99.9803 79.8163 99.9803 78.2017",
    fill: "url(#paint0_linear_719_7973)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M112.156 78.2017C112.156 79.8163 111.514 81.3647 110.373 82.5063C109.231 83.648 107.682 84.2893 106.068 84.2893C104.453 84.2893 102.905 83.648 101.763 82.5063C100.622 81.3647 99.9803 79.8163 99.9803 78.2017",
    stroke: "#333333",
    strokeWidth: 1.026,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M112.58 77.781C110.965 77.781 109.417 77.1397 108.275 75.998C107.133 74.8564 106.492 73.3079 106.492 71.6934V33.7314C106.492 32.1169 105.851 30.5685 104.709 29.4269C103.567 28.2852 102.019 27.6438 100.405 27.6438H68.4617C67.9222 27.6437 67.3901 27.5186 66.9071 27.2782C66.4241 27.0379 66.0033 26.689 65.6778 26.2587L59.9904 18.7347C59.6631 18.3076 59.2416 17.9619 58.7587 17.7246C58.2758 17.4873 57.7445 17.3648 57.2065 17.3667H37.7125C36.098 17.3667 34.5495 18.0081 33.4079 19.1497C32.2662 20.2914 31.6249 21.8398 31.6249 23.4543V71.7242C31.6249 73.3388 32.2662 74.8871 33.4079 76.0288C34.5495 77.1704 36.098 77.8118 37.7125 77.8118L112.58 77.781Z",
    fill: "url(#paint1_linear_719_7973)",
    stroke: "#333333",
    strokeWidth: 1.026,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M119.023 29.1008V77.6203H72.097V11.6314H101.701L119.023 29.1008Z",
    fill: "white",
    stroke: "#333333",
    strokeWidth: 1.026,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M119.023 29.1282H101.701V11.6314L119.023 29.1282Z",
    fill: "white",
    stroke: "#333333",
    strokeWidth: 1.026,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M101.701 15.9133H76.379V73.3385H114.741V29.1281H101.701",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M106.082 84.2893C104.467 84.2893 102.919 83.6479 101.777 82.5063C100.635 81.3646 99.994 79.8162 99.994 78.2017V40.2397C99.994 38.6252 99.3527 37.0768 98.211 35.9351C97.0694 34.7935 95.521 34.1521 93.9065 34.1521H61.9637C61.4246 34.1525 60.8927 34.0276 60.4102 33.7872C59.9277 33.5468 59.5076 33.1976 59.1832 32.767L53.4923 25.243C53.1658 24.816 52.7448 24.4703 52.2625 24.2329C51.7801 23.9956 51.2494 23.8731 50.7118 23.875H31.2178C29.6033 23.875 28.0549 24.5164 26.9133 25.658C25.7716 26.7997 25.1302 28.3481 25.1302 29.9626V78.2325C25.1302 79.847 25.7716 81.3954 26.9133 82.5371C28.0549 83.6787 29.6033 84.3201 31.2178 84.3201L106.082 84.2893Z",
    fill: "white",
    stroke: "#333333",
    strokeWidth: 1.026,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M70.907 60.7631H79.4809",
    stroke: "#333333",
    strokeWidth: 1.026,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M70.907 68.6565H89.7136",
    stroke: "#333333",
    strokeWidth: 1.026,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M117.761 16.3305L125.562 8.52945",
    stroke: "#333333",
    strokeWidth: 1.026,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M114.279 7.61633V14.5624",
    stroke: "#333333",
    strokeWidth: 1.026,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M126.475 19.8121H119.529",
    stroke: "#333333",
    strokeWidth: 1.026,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.5575 16.3613C22.1933 16.3613 23.5193 15.0353 23.5193 13.3996C23.5193 11.7638 22.1933 10.4378 20.5575 10.4378C18.9218 10.4378 17.5958 11.7638 17.5958 13.3996C17.5958 15.0353 18.9218 16.3613 20.5575 16.3613Z",
    stroke: "#05CB67",
    strokeWidth: 1.71,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M65.5888 16.9153C66.5597 16.9153 67.3467 16.1283 67.3467 15.1574C67.3467 14.1866 66.5597 13.3996 65.5888 13.3996C64.618 13.3996 63.8309 14.1866 63.8309 15.1574C63.8309 16.1283 64.618 16.9153 65.5888 16.9153Z",
    fill: "#05CB67"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.5288 83.0034C17.4996 83.0034 18.2866 82.2164 18.2866 81.2455C18.2866 80.2747 17.4996 79.4876 16.5288 79.4876C15.5579 79.4876 14.7709 80.2747 14.7709 81.2455C14.7709 82.2164 15.5579 83.0034 16.5288 83.0034Z",
    fill: "#05CB67"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48.7828 0.68399V5.76611",
    stroke: "#05CB67",
    strokeWidth: 1.368,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51.3272 3.22507H46.2417",
    stroke: "#05CB67",
    strokeWidth: 1.368,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48.8683 67.5142L46.5666 50.7289C46.531 50.4822 46.401 50.259 46.2041 50.1064L16.5082 27.5789C16.309 27.4283 16.0582 27.3628 15.8107 27.3968C15.5633 27.4308 15.3394 27.5614 15.1881 27.7601L0.704394 46.8506C0.55623 47.0458 0.491082 47.2916 0.523124 47.5346C0.556936 47.7818 0.687277 48.0056 0.885643 48.157L30.5815 70.6846C30.7772 70.8317 31.0226 70.8968 31.2655 70.8658L48.0509 68.5642C48.1735 68.549 48.2919 68.5097 48.3994 68.4487C48.5068 68.3877 48.6012 68.3061 48.6771 68.2086C48.7531 68.1111 48.809 67.9996 48.8418 67.8804C48.8746 67.7613 48.8836 67.6368 48.8683 67.5142ZM32.6677 60.2536C32.5418 59.3316 32.6921 58.393 33.0995 57.5564C33.507 56.7199 34.1533 56.0228 34.9568 55.5535C35.7603 55.0841 36.6849 54.8636 37.6137 54.9196C38.5425 54.9756 39.4339 55.3057 40.1751 55.8682C40.9164 56.4307 41.4743 57.2004 41.7782 58.0799C42.0821 58.9594 42.1185 59.9092 41.8827 60.8094C41.6469 61.7095 41.1496 62.5195 40.4535 63.1371C39.7575 63.7547 38.894 64.152 37.9721 64.2789C36.7351 64.4474 35.4818 64.1181 34.4873 63.3634C33.4928 62.6087 32.8384 61.4903 32.6677 60.2536Z",
    fill: "url(#paint2_linear_719_7973)",
    stroke: "#333333",
    strokeWidth: 1.026,
    strokeMiterlimit: 10
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_719_7973",
    x1: 99.9803,
    y1: 81.2455,
    x2: 112.156,
    y2: 81.2455,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3B94E2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2BB1FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_719_7973",
    x1: 78498.7,
    y1: 83303.5,
    x2: 97662.3,
    y2: 83303.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3B94E2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2BB1FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_719_7973",
    x1: 20.3525,
    y1: 26.605,
    x2: 26.4926,
    y2: 71.3709,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#05CB67"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.44,
    stopColor: "#05D166"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#05E163"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_719_7973"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 126.988,
    height: 84.8023,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDocument2);
export default __webpack_public_path__ + "static/media/document2.11fb3f3268852f4accd3a55e9c260ef8.svg";
export { ForwardRef as ReactComponent };